import { ThemeUIStyleObject } from 'theme-ui';

export const pageContainerStyles: ThemeUIStyleObject = {
  padding: ['1rem', '2rem', '3rem'],
  maxWidth: '1200px',
  margin: '0 auto',
};

export const headerStyles: ThemeUIStyleObject = {
  marginBottom: '2rem',
  paddingBottom: '1rem',
  borderBottom: '1px solid',
  borderColor: 'neutral/300',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const formContainerStyles: ThemeUIStyleObject = {
  backgroundColor: 'neutral/000',
  borderRadius: '0.5rem',
  padding: ['1.5rem', '2rem', '2.5rem'],
  boxShadow: 'small',
};

export const formSectionStyles: ThemeUIStyleObject = {
  marginBottom: '2rem',
  '&:last-of-type': {
    marginBottom: '1.5rem',
  },
};

export const sectionTitleStyles: ThemeUIStyleObject = {
  fontSize: '1.125rem',
  fontWeight: 700,
  color: 'neutral/800',
  marginBottom: '1.5rem',
  paddingBottom: '0.5rem',
  borderBottom: '1px solid',
  borderColor: 'neutral/200',
};

export const formRowStyles: ThemeUIStyleObject = {
  display: 'grid',
  gridTemplateColumns: ['1fr', '1fr 1fr'],
  gap: '1.5rem',
  marginBottom: '1.5rem',
};

export const fieldStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
};

export const labelStyles: ThemeUIStyleObject = {
  fontSize: '0.875rem',
  fontWeight: 600,
  color: 'neutral/700',
};

export const checkboxGroupStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: ['column', 'row'],
  gap: '1.5rem',
  padding: '1rem',
  backgroundColor: 'neutral/050',
  borderRadius: '0.25rem',
};

export const buttonGroupStyles: ThemeUIStyleObject = {
  gap: '1rem',
  justifyContent: 'flex-end',
  paddingTop: '1.5rem',
  borderTop: '1px solid',
  borderColor: 'neutral/200',
};
